<template>
  <div class="loading-container" id="redirect-loading">
    <div class="loading-text">
      <span>H</span>
      <span>S</span>
      <span>E</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Redirect',
  data() {
    return {
      email: '',
      password: '',
      errors: null,
      passwordType: 'password',
      countSubmit: 0
    }
  },
  apollo: {
  },
 async mounted() {
    var that = this;
    var url_redirect = '/home/modules';
    that.$router.push({path: url_redirect});
    // var url_redirect = await  that.$CoreService.geturlRedirectLogin();
    // // console.log("url_redirect",url_redirect)
    // if (that.$commonFuction.isEmpty(url_redirect)){
    //   // console.log("11111111111111")
    //   that.$router.push({path: that.$constants.URL_ERR.FOBIDDEN_AUTH});
    // }else {
    //   that.$router.push({path: url_redirect});
    // }
  }
}
</script>

<style lang="scss" scoped>
#redirect-loading {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: radial-gradient( circle farthest-corner at 10% 20%,  #0086c4e6 0.1%, #0086C4 94.2% );
  background-size: 100%;
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}

@keyframes movingLine {
  0% {
    opacity: 0;
    width: 0;
  }

  33.3%, 66% {
    opacity: 0.8;
    width: 100%;
  }
  
  85% {
    width: 0;
    left: initial;
    right: 0;
    opacity: 1;
  }

  100% {
  opacity: 0;
  width: 0;
  }
}

.loading-text {
  font-size: 5vw;
  line-height: 64px;
  letter-spacing: 10px;
  margin-bottom: 32px;
  display: flex;
  justify-content: space-evenly;
  position: relative;
  color: #fff;
  span {
    animation: moveLetters 2.4s infinite ease-in-out;
    transform: translatex(0);
    position: relative;
    display: inline-block;
    opacity: 0;
    text-shadow: 0px 2px 10px rgba(46, 74, 81, 0.3); 
  }
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: #fff;
    bottom: 0;
    left: 0;
    border-radius: 10px;
    animation: movingLine 2.4s infinite ease-in-out;
  }
}

@for $i from 1 through 7 {
  .loading-text span:nth-child(#{$i}) {
    animation-delay: $i * 0.1s;
  }
}

@keyframes moveLetters {
  0% {
    transform: translateX(-15vw);
    opacity: 0;
  }
  
  33.3%, 66% {
    transform: translateX(0);
    opacity: 1;
  }
  
  100% {
    transform: translateX(15vw);
    opacity: 0;
  }
}
</style>